<template>
  <div class='tienda' id='tienda'>
    <!--<div class="unishop">-->
      <v-toolbar class="sub-toolbar" flat>
        <Menu></Menu>
      </v-toolbar>
      <ProductsList :tienda="true"></ProductsList>
    <!--</div>-->
  </div>
</template>

<script>
import ProductsList from '../components/products_list/ProductsListContainer';
import Menu from '../components/menu/Menu.vue';

export default {
  name: 'index',
  data () { 
    return {
      id: '',
      modal: false,
    }
  },
  components: {
    ProductsList,
    Menu,
  },
  mounted() {
    this.cambioTitulo()
    document.getElementById("tienda").addEventListener('click', (e) => {
        this.$store.commit('showCarritoModal', false);
    })
  },
  methods : {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">shopping_cart</v-icon>`
      this.$store.state.titulo = "Tienda"
    },
  }
};
</script>
